module.exports = __webpack_public_path__ + "img/Accident - Impact assessment.ff317a4f.svg";